/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BulkCreatePersonasRequest,
  BulkCreatePersonasResponse,
  CreatePersonaRequest,
  HTTPValidationError,
  PersonaResponse,
} from '../models/index';
import {
    BulkCreatePersonasRequestFromJSON,
    BulkCreatePersonasRequestToJSON,
    BulkCreatePersonasResponseFromJSON,
    BulkCreatePersonasResponseToJSON,
    CreatePersonaRequestFromJSON,
    CreatePersonaRequestToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    PersonaResponseFromJSON,
    PersonaResponseToJSON,
} from '../models/index';

export interface BulkCreatePersonasApiPersonasBulkPostRequest {
    bulkCreatePersonasRequest: BulkCreatePersonasRequest;
    xApiKey?: string | null;
}

export interface CreatePersonaApiPersonasPostRequest {
    createPersonaRequest: CreatePersonaRequest;
    xApiKey?: string | null;
}

export interface DeletePersonaApiPersonasUserIdDeleteRequest {
    userId: string;
    xApiKey?: string | null;
}

export interface GetPersonaApiPersonasUserIdGetRequest {
    userId: string;
    xApiKey?: string | null;
}

export interface GetPersonasApiPersonasGetRequest {
    includeGroups?: boolean;
    includeRegion?: boolean;
    includeDevice?: boolean;
    includeAppParameters?: boolean;
    includeProxy?: boolean;
    xApiKey?: string | null;
}

export interface UpdatePersonaApiPersonasUserIdPutRequest {
    userId: string;
    createPersonaRequest: CreatePersonaRequest;
    xApiKey?: string | null;
}

/**
 * 
 */
export class PersonasApi extends runtime.BaseAPI {

    /**
     * Create multiple personas in a single bulk insert.
     * Bulk Create Personas
     */
    async bulkCreatePersonasApiPersonasBulkPostRaw(requestParameters: BulkCreatePersonasApiPersonasBulkPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkCreatePersonasResponse>> {
        if (requestParameters['bulkCreatePersonasRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkCreatePersonasRequest',
                'Required parameter "bulkCreatePersonasRequest" was null or undefined when calling bulkCreatePersonasApiPersonasBulkPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/personas/bulk`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkCreatePersonasRequestToJSON(requestParameters['bulkCreatePersonasRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkCreatePersonasResponseFromJSON(jsonValue));
    }

    /**
     * Create multiple personas in a single bulk insert.
     * Bulk Create Personas
     */
    async bulkCreatePersonasApiPersonasBulkPost(requestParameters: BulkCreatePersonasApiPersonasBulkPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkCreatePersonasResponse> {
        const response = await this.bulkCreatePersonasApiPersonasBulkPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new persona
     * Create Persona
     */
    async createPersonaApiPersonasPostRaw(requestParameters: CreatePersonaApiPersonasPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PersonaResponse>> {
        if (requestParameters['createPersonaRequest'] == null) {
            throw new runtime.RequiredError(
                'createPersonaRequest',
                'Required parameter "createPersonaRequest" was null or undefined when calling createPersonaApiPersonasPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/personas`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePersonaRequestToJSON(requestParameters['createPersonaRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonaResponseFromJSON(jsonValue));
    }

    /**
     * Create a new persona
     * Create Persona
     */
    async createPersonaApiPersonasPost(requestParameters: CreatePersonaApiPersonasPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PersonaResponse> {
        const response = await this.createPersonaApiPersonasPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a persona by user ID
     * Delete Persona
     */
    async deletePersonaApiPersonasUserIdDeleteRaw(requestParameters: DeletePersonaApiPersonasUserIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling deletePersonaApiPersonasUserIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/personas/{user_id}`;
        urlPath = urlPath.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Delete a persona by user ID
     * Delete Persona
     */
    async deletePersonaApiPersonasUserIdDelete(requestParameters: DeletePersonaApiPersonasUserIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deletePersonaApiPersonasUserIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a specific persona by user ID
     * Get Persona
     */
    async getPersonaApiPersonasUserIdGetRaw(requestParameters: GetPersonaApiPersonasUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PersonaResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getPersonaApiPersonasUserIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/personas/{user_id}`;
        urlPath = urlPath.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonaResponseFromJSON(jsonValue));
    }

    /**
     * Get a specific persona by user ID
     * Get Persona
     */
    async getPersonaApiPersonasUserIdGet(requestParameters: GetPersonaApiPersonasUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PersonaResponse> {
        const response = await this.getPersonaApiPersonasUserIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all personas with their associated groups
     * Get Personas
     */
    async getPersonasApiPersonasGetRaw(requestParameters: GetPersonasApiPersonasGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PersonaResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['includeGroups'] != null) {
            queryParameters['include_groups'] = requestParameters['includeGroups'];
        }

        if (requestParameters['includeRegion'] != null) {
            queryParameters['include_region'] = requestParameters['includeRegion'];
        }

        if (requestParameters['includeDevice'] != null) {
            queryParameters['include_device'] = requestParameters['includeDevice'];
        }

        if (requestParameters['includeAppParameters'] != null) {
            queryParameters['include_app_parameters'] = requestParameters['includeAppParameters'];
        }

        if (requestParameters['includeProxy'] != null) {
            queryParameters['include_proxy'] = requestParameters['includeProxy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/personas`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PersonaResponseFromJSON));
    }

    /**
     * Get all personas with their associated groups
     * Get Personas
     */
    async getPersonasApiPersonasGet(requestParameters: GetPersonasApiPersonasGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PersonaResponse>> {
        const response = await this.getPersonasApiPersonasGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing persona
     * Update Persona
     */
    async updatePersonaApiPersonasUserIdPutRaw(requestParameters: UpdatePersonaApiPersonasUserIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PersonaResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling updatePersonaApiPersonasUserIdPut().'
            );
        }

        if (requestParameters['createPersonaRequest'] == null) {
            throw new runtime.RequiredError(
                'createPersonaRequest',
                'Required parameter "createPersonaRequest" was null or undefined when calling updatePersonaApiPersonasUserIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/personas/{user_id}`;
        urlPath = urlPath.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePersonaRequestToJSON(requestParameters['createPersonaRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonaResponseFromJSON(jsonValue));
    }

    /**
     * Update an existing persona
     * Update Persona
     */
    async updatePersonaApiPersonasUserIdPut(requestParameters: UpdatePersonaApiPersonasUserIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PersonaResponse> {
        const response = await this.updatePersonaApiPersonasUserIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
